module.exports = __webpack_public_path__ + "static/media/hobbies-interests.e6eac488.svg";